import { AIFooter } from './AIFooter.js'

window.customElements.define('ai-footer', AIFooter)
